export class APIError extends Error {
    constructor(message, response) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
        this.response = response;
        this.name = 'APIError';
    }
    get status() {
        return this.response.status;
    }
}
//# sourceMappingURL=api_error.js.map